<section class="wrapper">
  <div class="box">
    <p class="logo">ESA</p>

    <div class="box-ghost">
      <div class="symbol"></div>
      <div class="symbol"></div>
      <div class="symbol"></div>
      <div class="symbol"></div>
      <div class="symbol"></div>
      <div class="symbol"></div>

      <div class="box-ghost-container">
        <div class="box-ghost-eyes">
          <div class="box-eye-left"></div>
          <div class="box-eye-right"></div>
        </div>
        <div class="box-ghost-bottom">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="box-ghost-shadow"></div>
    </div>

    <div class="box-description">
      <div class="box-description-container">
        <p class="box-description-title">{{ 'users.userNotFound.whoops' | translate }}!</p>
        <p *ngIf="isDisabled" class="box-description-text">{{ 'users.userNotFound.accountDisabled' | translate }}</p>
        <p *ngIf="!isDisabled" class="box-description-text">{{ 'users.userNotFound.cantFindAccount' | translate }}</p>
        <p class="contact-admin">{{ 'users.userNotFound.pleaseContactAdmin' | translate }}</p>
      </div>

      <a href='mailto:{{supportEmailAddress}}' target="_blank" class="box-button">{{ 'users.userNotFound.contactAdmin' | translate }}</a>

    </div>
  </div>
</section>
